<script lang="ts">
    import Head from "../header/Head.svelte";
    import {appManager} from "../AppManager";
    import type {ReRouteProjectData} from "../api/projects/data/reroute/ReRouteProjectData";
    import type {ReRouteDetailsData} from "../api/projects/data/reroute/ReRouteDetailsData";
    import ReRouteRouteplannerCard from "./ReRouteRouteplannerCard.svelte";

    export let id: string;

    let reRouteProjectData: ReRouteProjectData;
    let reRoutes: ReRouteDetailsData[] = [];

    const loadReRouteData = async () => {
        reRouteProjectData = await appManager.api.projects.getProjectReRoutes({
            projectId: id,
        });
        if (typeof reRouteProjectData === "undefined") {
            return;
        }

        reRoutes = reRouteProjectData.reRoutes;
    };
</script>

{#await loadReRouteData()}
    <div/>
{/await}
<Head/>
<section class="py-6 bg-light">
    <div class="container">
        <div class="row">
            <h1>{reRouteProjectData?.name ?? ""}</h1>

            <div class="mb-0 text-muted">
                {@html reRouteProjectData?.description ?? ""}
            </div>
        </div>
    </div>
</section>

<section class="bg-light min-height">
    <div class="container">
        <div class="row">
            {#if reRoutes.length > 0}
                {#each reRoutes as reRoute}
                    <ReRouteRouteplannerCard rerouteData={reRoute}/>
                {/each}
            {:else}
                <div class="mb-0 text-muted">
                    No published route planners in this project.
                </div>
            {/if}
        </div>
    </div>
</section>

<style>
    .min-height {
        min-height: 100%;
    }
</style>
